import React from "react"
import fetch from "isomorphic-fetch"

import { ISiteSearch } from "../../interfaces"
import { StaticQuery, graphql } from "gatsby"
import { useSiteMetaDataQuery } from "../../hooks/useSiteMetaDataQuery"

import "react-responsive-modal/styles.css"
import { Modal } from "react-responsive-modal"

import SearchResults from "../search-results"

class SiteSearch extends React.Component<ISiteSearch> {
  constructor(props) {
    super(props)
    this.state = {
      count: 0,
      per: 15,
      page: 1,
      q: "",
      results: [],
      showResultsModal: false
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.goTo = this.goTo.bind(this)
  }

  componentDidMount() {
    if (this.state.q !== "") {
      this.getResults()
    }
  }

  handleChange(event) {
    this.setState({ q: event.target.value })
    event.preventDefault()
  }

  async handleSubmit(event) {
    event.preventDefault()
    this.getResults()
  }

  getCategory() {
    const siteUrl = process.env.CMS_URL
    const application = siteUrl.replace("https://", "").split(".")[0]

    switch (application) {
      case "polebase":
        return "0xwww.polebase.com"
      case "redi-rock":
        return "0xwww.redi-rock.com"
      case "rosettahardscapes":
        return "0xwww.rosettahardscapes.com"
      case "asterbrands-cms-staging":
      case "asterbrands-com":
        return "0xwww.asterbrands.com"
      default:
        console.log("No matching application from ENV")
    }
  }

  getResults() {
    const url = new URL(process.env.ADD_SEARCH_INDEX_URL)
    const category = this.getCategory()
    url.searchParams.append("term", this.state.q)
    url.searchParams.append("categories", category)

    fetch(url.toString(), {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then((response) => response.json())
      .then((data) => {
        this.setState({ results: data.hits, count: data["total_hits"] }, () => {
          this.updateQuery()
          this.showResultsModal()
        })
      })
  }

  updateQuery() {
    window.history.replaceState(
      null,
      null,
      `?q=${this.state.q}&page=${this.state.page}&per=${this.state.per}`
    )
  }

  showResultsModal() {
    this.setState({
      showResultsModal: true
    })
  }

  truncate(str, num = 250) {
    return str.length > num ? str.slice(0, num > 3 ? num - 3 : num) + "..." : str
  }

  pluralize(str, n) {
    return n > 1 ? `${n} ${str}s` : `${n} ${str}`
  }

  goTo(n) {
    this.setState({ page: n }, () => {
      this.getResults()
    })
  }

  render() {
    const { search_intro, default_search_value, component, id } = this.props
    return (
      <div>
        <label htmlFor={`${component}-${id}`}>{search_intro}</label>
        <form onSubmit={this.handleSubmit}>
          <input
            id={`${component}-${id}`}
            type="search"
            placeholder={default_search_value}
            name="q"
            value={this.state.q}
            onChange={this.handleChange}
          />
        </form>
        <Modal
          open={this.state.showResultsModal}
          onClose={() => this.setState({ showResultsModal: false })}
          center
          focusTrapped={false}
          blockScroll={false}
        >
          <SearchResults
            show={this.state.showResultsModal}
            results={this.state.results}
            label={this.state.q}
          />
        </Modal>
      </div>
    )
  }
}

export default SiteSearch
